// 517 CHANGES BUTTON COLOR TO WHITE FOR ALL ACTIVE PAGES
document.addEventListener('DOMContentLoaded', function () {
    // Get the current page URL path
    let currentPage = window.location.pathname;

    // Select all buttons
    let buttons = document.querySelectorAll('.rotate');

    // Loop through each button
    buttons.forEach(function (button) {
        // Check if the button's href matches the current URL
        if (new URL(button.href).pathname.replace(/\/$/, '') === currentPage.replace(/\/$/, '')) {
            button.style.background = 'var(--kgwhite)'; // White for active button
            button.style.color = 'var(--kred1)';
        }
    });
});

// 517 CHANGES BUTTON COLOR ON WOODS FOR LEFT, AND HEAD ONLY - the right hand color is changed via the above text
document.addEventListener('DOMContentLoaded', function () {
    let currentPage = window.location.pathname;
    let buttons = document.querySelectorAll('.rotate');

    buttons.forEach(function (button) {
        let href = button.getAttribute('href');

        // match current page or same product in left-hand or head-only versions
        if (
            href === currentPage ||
            currentPage.includes(href.replace('/products/', '').replace('-right-hand', '-left-hand')) ||
            currentPage.includes(href.replace('/products/', '') + '-head-only') ||
            currentPage.includes(href.replace('/products/', '').replace('-right-hand', '-left-hand-head-only'))
        ) {
            button.style.background = 'var(--kgwhite)';
            button.style.color = 'var(--kred1)';
        }
    });
});

// 517 CHANGES TOP BUTTONS COLOR ON PRO, X, XX and LD TOUR DRIVER FOR LEFT, AND LEFT & RIGHT HEAD ONLY
document.addEventListener('DOMContentLoaded', () => {
    const path = window.location.pathname;

    const map = [
        {
            href: '/products/formula-fire-pro-tour-pro-golf-conforming-right-hand',
            match: [
                '/products/formula-fire-pro_usga-conforming-left-hand',
                '/products/formula-fire-pro_usga-conforming-left-hand-head-only',
            ],
        },
        {
            href: '/products/formula-fire-tour-x-right-hand-high-cor',
            match: ['/products/formula-fire-x_left_hand_high-cor', '/products/formula-fire-x_left_hand_high-cor-head-only'],
        },
        {
            href: '/products/formula-fire-tour-xx-right-hand-super-high-cor',
            match: [
                '/products/formula-fire-xx_left-hand_super_high-cor',
                '/products/formula-fire-xx_left-hand_super_high-cor-head-only',
                '/products/formula-fire-xx_right-hand_super_high-cor-head-only',
            ],
        },
        {
            href: '/products/formula-fire-long-drive-tour_right-hand_usga-conforming',
            match: [
                '/products/formula-fire-long-drive-tour_left-hand_usga-conforming',
                '/products/formula-fire-long-drive-tour_left-hand_usga-conforming-head-only',
            ],
        },
    ];

    map.forEach(({ href, match }) => {
        if (match.includes(path)) {
            const button =
                document.querySelector(`a.rotate-four.rotate[href="${href}"]`) ||
                document.querySelector(`a.rotate[href="${href}"]`);
            if (button) {
                button.style.backgroundColor = 'var(--kgwhite)';
                button.style.color = 'var(--kred1)';
            }
        }
    });
});

// 517 CHANGES MIDDLE BUTTONS COLOR ON PRO, X, XX and LD TOUR DRIVER FOR LEFT, AND LEFT & RIGHT HEAD ONLY
document.addEventListener('DOMContentLoaded', function () {
    const currentPage = window.location.pathname;

    const map = [
        {
            href: '/products/formula-fire-pro-tour-pro-golf-conforming-right-hand',
            match: [
                '/products/formula-fire-pro_usga-conforming-left-hand',
                '/products/formula-fire-pro_usga-conforming-left-hand-head-only',
            ],
        },
        {
            href: '/products/formula-fire-tour-x-right-hand-high-cor',
            match: ['/products/formula-fire-x_left_hand_high-cor', '/products/formula-fire-x_left_hand_high-cor-head-only'],
        },
        {
            href: '/products/formula-fire-tour-xx-right-hand-super-high-cor',
            match: [
                '/products/formula-fire-xx_left-hand_super_high-cor',
                '/products/formula-fire-xx_left-hand_super_high-cor-head-only',
                '/products/formula-fire-xx_right-hand_super_high-cor-head-only',
            ],
        },
    ];

    map.forEach(({ href, match }) => {
        if (match.includes(currentPage)) {
            document.querySelectorAll('.rotate').forEach(function (button) {
                if (button.getAttribute('href') === href) {
                    button.style.background = 'var(--kgwhite)';
                    button.style.color = 'var(--kred1)';
                }
            });
        }
    });
});

// 517 FIX: FORCE ACTIVE STATE FOR 2-WOOD FAIRWAY WOOD BECAUSE HANDLE IS DIFFFERENT
document.addEventListener('DOMContentLoaded', function () {
    const currentPage = window.location.pathname;

    const twoWoodPaths = [
        '/products/formula-fire-2-wood-10-right-hand',
        '/products/formula-fire-2-wood-10-right-hand-head-only'
    ];

    if (twoWoodPaths.some(path => currentPage.includes(path))) {
        document.querySelectorAll('.rotate').forEach(button => {
            if (button.textContent.includes('2 Wood')) {
                button.style.background = 'var(--kgwhite)';
                button.style.color = 'var(--kred1)';
            }
        });
    }
});



